import { Fancybox } from "@fancyapps/ui";

export function kkTableFancybox() {
    const tableLinks = document.querySelectorAll('[data-fancybox^="table-"]');
    if (tableLinks.length === 0) return;

    const groups = new Set();
    tableLinks.forEach((link) => groups.add(link.getAttribute('data-fancybox')));

    groups.forEach((groupId) => {
        Fancybox.bind(`[data-fancybox="${groupId}"]`, {
            loop: true,
            protect: false,
            controls: false,
            caption: (fancybox, item) => {
                return item.caption || '';
            },
            contentClick: "iterateZoom",
            Images: {
                Panzoom: {
                    maxScale: 2,
                },
            },
            Toolbar: {
                display: {
                    left: ["infobar"],
                    middle: [],
                    right: ["iterateZoom", "close"],
                }
            }
        });
    });
}
